<template>
  <v-flex>
    <v-title>Internet</v-title>
    <v-dialog v-model="showModal" max-width="90%">
      <customer-address
        :add="true"
        @close="showModal = false"
      ></customer-address>
    </v-dialog>
    <v-dialog v-model="showContact" max-width="90%">
      <contact-modal
        v-if="showContact"
        :contact="contact"
        @closeContact="contactClosed"
      ></contact-modal>
    </v-dialog>
    <Backup4GDialog
      v-if="dialog.active"
      ref="backupDialog"
      :handset="dialog.target == 'edit' ? currentHandset : {}"
      :item="selectedInternet"
      :handsets="handsets" 
      :dialog="dialog"
      :current-index="currentIndex"
      @update:internet="updateInternet"
      @closeDialog="closeDialog"
    ></Backup4GDialog>
    <v-dialog v-model="sqValidation" max-width="35%">
      <v-title>5G is currently not available at this addresses:</v-title>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="py-3">
              <ul>
                <li v-for="(address, index) in filteredAddress" :key="index">
                  {{ address }}
                </li>
              </ul>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="light-grey" @click="sqValidation = !sqValidation">
              Close
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoading" modal persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Order saving, conducting Service qualification if required...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card>
      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text>
          <v-layout row justify-space-between>
            <existing-services
              :dialog="existingDialog"
              :headers="headers"
              :account="customer.customer.ubAccountNo"
              :service-type="'NBN'"
              @close="existingDialog = !existingDialog"
              @selectedItems="addToTable"
              @loaded="existingServicesLoaded"
            ></existing-services>
          </v-layout>
          <v-layout row wrap>
            <v-flex v-if="showButton" lg12>
              <v-btn
                color="primary"
                :disabled="internetServices.length == 0"
                @click="showExistingServices()"
              >
                Show Existing Services
              </v-btn>
              <v-progress-circular
                v-if="!servicesLoaded"
                indeterminate
                color="info"
                small
              ></v-progress-circular>
            </v-flex>
            <v-flex sm3 md3 lg3>
              <v-layout wrap row>
                <v-flex sm9 md8 lg8>
                  <vonex-text
                    ref="txt"
                    v-model="NumberOfServiceInternet"
                    :options="fieldConditions"
                    hide-details
                    type="number"
                    name="txt"
                    min="1"
                    label="Number of Services"
                    @keyup="changeRows"
                  ></vonex-text>
                </v-flex>
                <v-flex sm2 md2 lg2>
                  <v-btn title="Add Row" class="iconBtn" @click="onAdd">
                    <v-icon>add</v-icon>
                  </v-btn>
                  <br />
                  <v-btn title="Remove Row" class="iconBtn" @click="onRemove">
                    <v-icon>remove</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm9>
              <v-alert v-show="isNBN250" color="secondary">
                NBN250 is only available at select HFC and FTTP connection
                addresses. Ensure a Service Qualification check has been
                completed and NBN250 availability at the address has been
                confirmed before placing order.
              </v-alert>
            </v-flex>
            <v-layout justify-end ma-0>
              <v-flex v-if="rows[0] && rows[0].internetID > 0" xs6>
                <v-btn
                  color="primary"
                  @click="deleteFromOrder(rows[0].internetID)"
                >
                  Delete from {{ isQuote ? 'Quote' : 'Order' }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-flex sm12 md12 lg12>
              <table
                v-if="rows"
                class="table table table-striped table-bordered mobile-table"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th style="width: 150px; max-width: 100%">Type</th>
                    <th>SQ Reference Number</th>
                    <th scope="col" style="width: 120px; max-width: 100%">
                      <div>Contract Length</div>
                      <div>
                        <div v-if="rows.length > 1">
                          <v-btn
                            color="primary"
                            small
                            round
                            title="copy down"
                            @click="copyDown('contractTerm')"
                          >
                            Copy Down
                          </v-btn>
                        </div>
                      </div>
                    </th>
                    
                    <th scope="col">
                      <div style="float: left">Rate Plan</div>
                      <div style="float: right">
                        <div v-if="rows.length > 1">
                          <v-btn
                            color="primary"
                            small
                            round
                            title="copy down"
                            @click="copyDown('ratePlanID')"
                          >
                            Copy Down
                          </v-btn>
                        </div>
                      </div>
                    </th> 
                
                    <th scope="col">
                      <div style="float: left">4G Backup</div>
                      <div style="float: right"></div>
                      <div style="float: right">
                        <div v-if="rows.length > 1">
                          <v-btn
                            color="primary"
                            small
                            round
                            title="copy down"
                            @click="copyDown('bundleId')"
                          >
                            Copy Down
                          </v-btn>
                        </div>
                      </div>
                    </th>
                    <th scope="col">
                      <div style="float: left">Modem Required</div>
                    </th>
                    <th scope="col">
                      <div style="float: left">Service Level</div>
                      <div style="float: right">
                        <div v-if="rows.length > 1">
                          <v-btn
                            color="primary"
                            small
                            round
                            title="copy down"
                            @click="copyDown('bundleId')"
                          >
                            Copy Down
                          </v-btn>
                        </div>
                      </div>
                    </th>

                    <th scope="col">
                      <div style="float: left">Address</div>
                      <div style="float: right">
                        <v-btn
                          color="primary"
                          small
                          round
                          @click="showModal = true"
                        >
                          Add
                        </v-btn>
                      </div>
                    </th>
                    <th scope="col">
                      <div>On Site Contact</div>
                      <div>
                        <v-btn
                          small
                          round
                          color="primary"
                          style="display: inline-block"
                          @click="addInternetContact()"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          v-if="rows.length > 1"
                          color="primary"
                          small
                          round
                          title="copy down"
                          style="display: inline-block"
                          @click="copyDown('contactID')"
                        >
                          Copy Down
                        </v-btn>
                      </div>
                    </th>
                     <th scope="col">
                      <div>recontract</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in rows" :key="index">
                    <td align="center">
                      <!-- <div v-show="item.internetID">
                        <v-icon color="green">check_circle</v-icon>
                        <v-icon @click="removeRow(index)">delete</v-icon>
                      </div>-->
                      <v-icon
                        v-show="item.internetID && !item.sqInvalid"
                        color="green"
                      >
                        check_circle
                      </v-icon>
                      <v-icon v-show="item.sqInvalid" color="red">
                        cancel
                      </v-icon>
                      <v-icon @click="deleteRow(item, index)">delete</v-icon>
                    </td>
                    <td>
                      <vonex-select
                        :ref="'internetType' + index"
                        v-model="item.internetType"
                        :options="fieldConditions"
                        item-value="value"
                        item-text="text"
                        :items="internetTypeNew"
                        hide-details
                        :rule="`required`"
                        :name="'internetType' + index"
                        class="custom-td"
                        @change="onServiceTypeChange(item)"
                      ></vonex-select>
                    </td>
                    <td>
                      <vonex-text
                        :ref="'serviceNumber' + index"
                        v-model="item.serviceNumber"
                        :options="fieldConditions"
                        hide-details
                        type="text"
                        class="form-control custom-td"
                        :name="'serviceNumber' + index"
                      ></vonex-text>
                    </td>
                    <td>
                      <vonex-select
                        v-model="item.contractTerm"
                        :options="fieldConditions"
                        item-value="contractMonths"
                        item-text="contractMonths"
                        :items="validContractMonths(item)"
                        hide-details
                        :rule="`contractMonths`"
                        :name="'contractTerm' + index"
                        class="custom-td"
                      ></vonex-select>
                    </td>
                   
                    <td>
                      <vonex-select
                        v-model.number="item.ratePlanID"
                        :options="fieldConditions"
                        item-value="ratePlanID"
                        item-text="ratePlanDescription"
                        :items="validRatePlans(item)"
                        hide-details
                        class="form-control custom-td"
                        :rule="`required|planId`"
                        :name="'ratePlanID' + index"
                        @change="
                          checkNBN250(item, index);
                          onSelect(item.ratePlanID, index);
                        "
                      ></vonex-select>
                    </td>
                   
                  
                    <td>
                      <div
                        v-if="
                          item.internetType &&
                          allFlags.SOG4015 &&
                          item.dataBackup
                        "
                        class="d-flex pa-2"
                      >
                        <span>
                          {{ retrieveHandset(item.dataBackup).model }}
                        </span>

                        <div>
                          <span
                            @click="editBackup(item, index)"
                            style="cursor: pointer"
                            class="material-icons"
                          >
                            edit
                          </span>

                          <span
                            @click="removeDataBackupFromInternet(item)"
                            class="material-icons ml-2"
                            style="cursor: pointer; color: #ff3737"
                          >
                            delete_forever
                          </span>
                        </div>
                      </div>
                      <v-btn
                        v-else-if="allFlags.SOG4015"
                        color="primary"
                        class="pa-2"
                        small
                        round
                        :disabled="item.internetType == 'nbn'"
                        @click="addBackup(item, index)" 
                      >
                        Add
                      </v-btn>
                      <vonex-select 
                      v-else
                        v-model="item.bundleId"
                        :options="fieldConditions"
                        item-value="bundleId"
                        item-text="detail"
                        :items="validBundlePlans(item)"
                        hide-details
                        class="form-control custom-td"
                        :name="'bundleId' + index"
                        :disabled="item.disable4GBackUp || item.internetType == 'nbn'"
                        @change="updateBackup(item)"
                      ></vonex-select>
                    </td>
                    <td scope="col">
                      <div>
                        <vonex-select
                         v-if="['nbn'].includes(item.internetType) && !has4GBackup(item)"
                         v-model="item.modemRequired"
                          :items="modemOptions"
                          item-value="value"
                          item-text="text"
                          hide-details
                          class="custom-td"
                          :rule="`required`"
                        ></vonex-select>
                      </div>
                    </td>
                    <!-- service level -->
                    <td>
                      <vonex-select
                        v-model="item.serviceLevelId"
                        :options="fieldConditions"
                        item-value="serviceLevelID"
                        item-text="detail"
                        :items="validBundleService(item, index)"
                        hide-details
                        class="form-control custom-td"
                        :name="'serviceLevelId' + index"
                        :rule="
                          item.internetType == 'nbnEnterprise'
                            ? 'serviceId'
                            : ''
                        "
                        :disabled="item.internetType !== 'nbnEnterprise'"
                      ></vonex-select>
                    </td>
                    <td :class="{ sqResult: item.sqInvalid }">
                      <vonex-select
                        v-model="item.addressID"
                        :options="fieldConditions"
                        item-value="addressID"
                        item-text="formattedAddress"
                        :items="address.addresses"
                        hide-details
                        class="form-control custom-td"
                        :name="'streetAddress' + index"
                      ></vonex-select>
                      <span v-if="item.sqInvalid" class="caption red--text">
                        5G is unavailable at this address
                      </span>
                    </td>
                    <td>
                      <vonex-select
                        v-model="item.contactID"
                        :options="fieldConditions"
                        item-value="contactID"
                        item-text="contactName"
                        :items="contacts"
                        hide-details
                        class="form-control custom-td"
                        :name="'contact' + index"
                        :rule="
                          item.internetType &&
                          ['mbe', 'nbn', '5g'].includes(
                            item.internetType.toLowerCase()
                          )
                            ? 'required'
                            : ''
                        "
                      ></vonex-select>
                    </td>
                    <td>
                       <v-checkbox
            v-model="item.upgrade"
          ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="hasModem">
                  <tr>
                    <td align="center" colspan="6"></td>
                    <td
                      style="padding: 5px 7px !important"
                      align="center"
                      class="font-weight-bold"
                      colspan="3"
                    >
                     Total Modem Cost:{{ totalModemCost | currency }}
                    </td>
                    
                  </tr>
                  
                </tfoot>
              </table>
            </v-flex>
            <v-layout>
              <v-flex xl1>
                 <v-btn :disabled="invalid" color="primary" @click="submit">
                  Save Internet
                </v-btn>
              </v-flex>
            </v-layout>
              <v-flex v-if="allFlags.SOG4419" xs12 class="ml-2">
                <span class="caption">
                  <span class="red--text">*</span>
                  <strong>Note:</strong> Plan override in operation
                </span>
              </v-flex>
              <v-flex
                v-if="
                  rows.every((x) => x.bundleId > 0) &&
                  (allFlags.SOG9302 ? !rows.some((x) => hasFibre4GBackUp(x)) : true) &&
                  rows.some((x) => x.internetType !== 'nbnEnterprise')
                "
                class="ml-4"
              >
                <span class="caption">
                  <span class="red--text">*</span>
                  A hardware order has been created for the Hybrid modem that
                  includes any applicable charge, dependent on the plan. This
                  will be added to the customers first bill if no other hardware
                  has been purchased.
                </span>
              </v-flex>

              <v-flex
                v-if="allFlags.SOG9302 && rows.some((x) => x.internetType == 'fibre' && hasFibre4GBackUp(x))"
              >
                <span class="caption">
                  • The 4G Mobile Backup is a SIM only service, no hardware is included and the customer will need to supply their own compatible hardware that can support 4G/LTE SIM cards. <br/>
                  • 4G Mobile Backup service includes 100GB of included data. Additional data charged at $5 per GB. <br/> 
                  • A 1 month contract term applies to the 4G Mobile Backup service. <br/>
                  • See Fibre 4G Backup CIS for full terms.
                </span>
              </v-flex>
            </v-layout>
            <message-alert :component="message"></message-alert>
          </v-layout>
        </v-card-text>
      </ValidationObserver>
    </v-card>
  </v-flex>
</template>
<script>
import { createNamespacedHelpers, mapGetters } from 'vuex';
import { httpError } from '@/models/httpError';
import { Contact } from '@/models/Contact';
import ExistingServices from '@/components/dialogs/existing-services-dialog';
import Utils from '@/mixins/utils.mixin';
import {
  mapCustomerFields,
  mapInternetFields,
  mapInternetMultiRowFields,
} from '../store/modules/orders';

import Backup4GDialog from '@/components/dialogs/Backup4GDialog';

const { mapActions: mapAddressActions } =
  createNamespacedHelpers(`orders/address`);
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const { mapActions: mapInternetActions, mapMutations: mapInternetMutations } =
  createNamespacedHelpers(`orders/internet`);
import ContactModal from './contact-modal.vue';
 const { mapActions: mapIPVoiceActions, mapGetters: mapOrderGetters } =
  createNamespacedHelpers(`orders/ipVoice`);
const { mapActions: mapSipActions } = createNamespacedHelpers(`orders/Sip`);
const { mapActions: mapRatePlanActions } =
  createNamespacedHelpers(`orders/ratePlan`);
const { mapActions: mapNoteActions } = createNamespacedHelpers(`orders/notes`);
const { mapActions: mapSQAddressActions, mapGetters: mapSQAddressGetters } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapActions: mapSQActions, mapGetters: mapSQGetters } =
  createNamespacedHelpers(`orders/sq`);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);
const { mapActions: mapCustomerActions } =
  createNamespacedHelpers(`orders/customer`);
const { mapActions: mapHardwareActions } =
  createNamespacedHelpers(`orders/hardware`);

const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);

export default {
  name: 'CreateInternet',
  components: {
    ContactModal,
    ExistingServices,
    Backup4GDialog,
  },
  mixins: [Utils],
  data() {
    return {
      showModal: false,
      showContact: false,
      isDataLoading: false,
      NumberOfServiceInternet: 1,
      isSaved: false,
      contact: {},
      hasIP: false,
      servicesChecked: false,
      ratePlans: [],
      bundles: [],
      isNBN250: false,
      servicesLoaded: false,
      internetServices: [],
      existingDialog: false,
      addresses: [],
      nbnHardwares:[],
      hasBackup: false,
       headers: [
        { text: 'Customer Number', value: 'customerNumber', sortable: false },
        { text: 'Service Number', value: 'csn', sortable: false },
        {
          text: 'Rate Plan Description',
          value: 'ratePlanDescription',
          sortable: false,
        },
        { text: 'Contract Months', value: 'contractMonths', sortable: false },
        { text: 'Service Added', value: 'serviceDateAdded', sortable: false },
        { text: 'Contract End', value: 'contractEnd', sortable: false },
        { text: 'Upgrade', value: 'upgrade', sortable: false },
      ],
      internetType: [
        { text: 'NBN', value: 'nbn' },
        { text: 'NBN Enterprise', value: 'nbnEnterprise' },
        { text: 'Fibre', value: 'fibre' },
        { text: '5G', value: '5g' },
        { text: 'HWBB', value: 'hwbb' },
      ],
      internetTypeNew: [
        { text: 'NBN', value: 'nbn' },
        { text: 'Business Fibre', value: 'fibre' },
        { text: '5G', value: '5g' },
        { text: 'HWBB', value: 'hwbb' },
      ],
      disable4GBackUp: false,
      sqValidation: false,
      filteredAddress: [],
      isLoading: false,
      noneOption: {
        bundleId: 0,
        bundleName: 'None',
        contractMonths: 0,
        detail: 'None',
        excludeFromTCV: false,
        handsetId: 0,
        id: 0,
        ratePlanId: 0,
        rrpInc: 0,
        usageType: '',
      },
      dialog: {
        title: '',
        target: '',
        active: false,
      },
      handsets: [],
      selectedInternet: {},
      currentIndex: 0,
      modemOptions:[
        { text: 'Yes', value: true },
        { text: 'No', value:false },
      ]
    };
  },
  computed: {
    // ...mapOrderGetters(['hasIP']),
    ...mapOrderState(['address', 'ipVoice', 'Sip', 'customer', 'notes']),
    ...mapOrderState({ order: 'rows' }),
    ...mapInternetMultiRowFields(['rows', 'contacts']),
    ...mapInternetFields(['message']),
    ...mapCustomerFields(['customer.customerID', 'customer.hasPbxService']),
    ...mapGetters('orders', [
      'isResidential',
      'isQantas',
      'isExistingCustomer',
      'isQuote',
      'hasNoDDProvided',
    ]),
    ...mapSQAddressGetters(['fullAddress']),
    ...mapSQGetters(['sq5gResult']),
    ...mapFeatureFlagGetters(['allFlags']),
    showButton() {
      let vm = this;
      return (
        vm.order[0] && vm.order[0].existingCustomer
      );
    },
    hasUnsuccessfulSQ() {
      let vm = this;
      let filteredRow = vm.rows
        .filter((row) => row.internetType == '5g')
        .filter((row) => !row.sqSuccessful);

      if (filteredRow.length > 0) {
        vm.rows.forEach((row) => {
          if (row.internetType == '5g' && !row.sqSuccessful)
            row.sqInvalid = true;
          row.formattedAddress = vm.address.addresses
            .filter((x) => x.addressID == row.addressID)
            .map((x) => x.formattedAddress)[0];
        });
        vm.filteredAddress = [
          ...new Set(filteredRow.map((x) => x.formattedAddress)),
        ];
        return true;
      }

      return false;
    },

    hasModem (){
      let vm = this;
      return vm.rows.some(e=>e.modemRequired)
     },

     totalModemCost(){
      if (!this.hasModem) {
        
        return 0
      }
      else{
        let total = 0; 
         this.rows.filter(e=>e.modemRequired).forEach(e => {
          let contractLength = e.contractTerm
          const nbnHardware =this.nbnHardwares.filter(item=>item.contractLength == contractLength)[0];
          if (nbnHardware) {
            total+= nbnHardware.rrp;
           } 
        });
         return total;
       }
     }


  },
  async mounted() {
    let vm = this;
    vm.handsets = await vm.getHandsets();
    vm.nbnHardwares = await vm.getNBNHardwares(false);

    vm.setMessage(new httpError());
    if (this.customerID > 0) {
      let bundles = await vm.getBundles();
      let ratePlans = await vm.getRatePlans();
      let addresses = await vm.getAllAddresses(vm.customerID);
      let contacts = await vm.getContacts(vm.order[0].orderID);
      let internets = await vm.getInternet();
      let customers = await vm.getCustomer(vm.customerID);

      await Promise.all([
        addresses,
        internets,
        contacts,
        ratePlans,
        bundles,
        customers,
      ]);
      this.ratePlans = ratePlans.data;
      this.bundles = bundles;
      if (vm.rows.length > 0) {
        vm.NumberOfServiceInternet = vm.rows.length;
      } else {
        vm.NumberOfServiceInternet = 1;
        vm.addRow({ addressID: addresses[0].addressID, months: 24 });
      }
      vm.checkDisabled4gBackup();
      vm.hasIPServices();

      vm.populateSips();
      //check notes - assume already loaded.
      vm.hasUnsuccessfulSQ;
    }
  },
  methods: {
    ...mapHardwareActions(['getHandsets' ,'getNBNHardwares']),
    ...mapNoteActions(['addNote', 'saveNote', 'getNotes', 'delNote']),
    ...mapRatePlanActions(['getRatePlans', 'getBundles']),
    ...mapIPVoiceActions(['getServices', 'getIPVoice']),
    ...mapInternetActions([
      'setMessage',
      'getInternet',
      'addNewInternet',
      'addContacts',
      'getContacts',
      'removeRows',
      'removeRow',
      'removeIndex',
      'removeDataBackup',
    ]),
    ...mapAddressActions([
      'resetAddress',
      'getAddress',
      'addAddress',
      'updateAddress',
      'getAllAddresses',
      'searchAddress',
    ]),
    ...mapSipActions(['populateSips']),
    ...mapInternetMutations([
      'addRow',
      'delRow',
      'addContact',
      'addUpgradeRow',
    ]),
    ...mapSQAddressActions(['getFullAddress']),
    ...mapSQActions([
      'reset5gSq',
      'resetHasSectorId',
      'addressQuery',
      'serviceQualification5G',
      'setOrderType',
      'setLocationID',
      'resetFormattedSQResult',
    ]),
    ...mapCustomerActions(['getCustomer']),
    has4GBackup(item){
      let vm = this;
      let selected_ratePlan = vm.ratePlans.find(x => x.ratePlanID == item.ratePlanID);
      
      return (vm.bundles.some(x => x.bundleId === item.bundleId && x.bundleName === "NBN with 4G Backup") || item.contractTerm == -1 || item.internetType !== 'nbn') || 
      (selected_ratePlan && selected_ratePlan.ratePlanDescription.includes("Assure"));
    },
    hasFibre4GBackUp(item) {
      const ratePlan = this.ratePlans.find((x) => x.ratePlanID == item.ratePlanID);
      return !!(ratePlan && ratePlan.fibre4GBackUp);
    },
    addBackup(item, index) {
      const vm = this;
      vm.dialog = {
        title: 'Add 4G Backup',
        target: 'add',
        active: true,
      };

      vm.currentIndex = index;
      vm.selectedInternet = item;
    },
    closeDialog() {
      const vm = this;
      vm.dialog.active = false;
    },
    retrieveHandset(item) {
      const vm = this;
      let index = vm.handsets.findIndex((x) => x.handsetID == item.hardwareID);
      let handset = {
        model: '',
      };
      if (index !== -1) {
        vm.currentHandset = vm.handsets[index];
        handset = vm.handsets[index];
      } else {
        this.currentHandset = {
          model: '',
        };
      }
      return handset;
    },
    checkNBN250(item, index) {
      let vm = this;
      if (item.ratePlanID) {
        let ratePlan = vm.ratePlans.filter(
          (x) => x.ratePlanID === item.ratePlanID
        )[0];
        let desc = '';

        if (typeof ratePlan.ratePlanDescription !== 'undefined') {
          desc = ratePlan.ratePlanDescription.toLowerCase();

          if (desc.includes('nbn250')) vm.isNBN250 = true;
          else vm.isNBN250 = false;
        }

        vm.rows[index].disable4GBackUp = ratePlan.disable4GBackUp;
      }
    },
    addInternetContact() {
      this.addContact(new Contact());
      this.contact = this.contacts[this.contacts.length - 1];
      this.showContact = true;
    },

    validContractMonths: function (service) {
      if (this.hasNoDDProvided && !this.isQuote) return [0];
      const uniqueFilter = (value, index, self) => {
        return self.indexOf(value) === index;
      };

      if (service.internetType === 'hwbb') {
        let months = this.bundles
          .map((e) => e.contractMonths)
          .filter(uniqueFilter)
          .sort((a, b) => a - b);

        return months;
      }
      if (service !== null && service.internetType !== null) {
        let plans = this.ratePlans
          .filter(
            (e) =>
              e.usageType.toLowerCase() == service.internetType.toLowerCase()
          )
          .filter((x) =>
            service.internetType.toLowerCase() === 'nbn'
              ?
                (this.isResidential ? true : x.residential == false)
              : true
          );

        var conMonths = plans
          .map((e) => e.contractMonths)
          .filter(uniqueFilter)
          .sort((a, b) => a - b);

        return conMonths;
      }
    },
    validRatePlans: function (service) {
      if (service.internetType == null) return null;

      if (['hwbb', '5g'].includes(service.internetType.toLowerCase())) {
        let usageType =
          service.internetType.toLowerCase() == '5g'
            ? 'fiveG'
            : service.internetType;
        let bundlePlans = this.bundles.filter((e) => {
          return (
            e.contractMonths == service.contractTerm && e.usageType == usageType
          );
        });

        let customPlans = [];

        bundlePlans.forEach((x) => {
          let y = {
            ratePlanID: x.ratePlanId,
            ratePlanDescription: x.detail ? x.detail : x.bundleName,
          };

          let activePlan = this.ratePlans
            .filter((r) => r.archived == false && r.ratePlanID == y.ratePlanID)
          
          if(activePlan.length > 0)
            customPlans.push(y);
        });

        return customPlans;
      }

      let plans = this.ratePlans
        .filter((x) => x.archived == false)
        .filter(
          (e) =>
            e.contractMonths == service.contractTerm &&
            e.usageType.toLowerCase() == service.internetType.toLowerCase()
        )
        .filter((e) => {
          return !this.allFlags.SOG4419
            ? this.hasIP
              ? e.ipBundle == e.ipBundle
              : e.ipBundle == false
            : true;
        })
        .filter((x) =>
          service.internetType.toLowerCase() === '5g' ? !x.isWholesale : true
        );
      let assureUpgrade = this.internetServices.filter(
        (x) => x.csn === service.serviceNumber
      );
      if (
        (assureUpgrade.length > 0 || this.hasPbxService) &&
        service.internetType === 'nbn' &&
        this.order[0].existingCustomer
      )
        return plans;
      else return plans.filter((x) => x.upgrade === false);
    },
    validBundlePlans: function (service) {
      let vm = this;
      vm.noneOption.usageType = usageType;
      if (service.internetType == null) return [];
      let usageType =
        service.internetType.toLowerCase() == '5g'
          ? 'fiveG'
          : service.internetType.toLowerCase();
      let bundleId = vm.bundles
        .filter((x) => {
          return (
            x.ratePlanId === service.ratePlanID &&
            x.usageType.toLowerCase() == usageType
          );
        })
        .map((y) => y.bundleId)[0];

      if (service.disable4GBackUp == true) {
        let no4GBackUp = vm.bundles.filter(
          (e) => e.bundleId == service.bundleId
        );
        no4GBackUp.push(vm.noneOption);
        return no4GBackUp;
      }

      if (bundleId && usageType.toLowerCase() != 'nbnenterprise') {
        let filteredBundles = vm.bundles.filter(
          (e) =>
            e.bundleId === bundleId &&
            e.contractMonths == service.contractTerm &&
            e.usageType.toLowerCase() == usageType
        );
        filteredBundles.push(vm.noneOption);
        if (filteredBundles.length > 1) {
          vm.rows.forEach((x) => {
            let ratePlan = vm.ratePlans.filter(
            (y) => y.ratePlanID === service.ratePlanID
          )[0];
          if (ratePlan !== undefined){
            if (ratePlan.disable4GBackUp) {
              if (x.ratePlanID === service.ratePlanID) {
                x.bundleId = filteredBundles[0].bundleId;
              }
            }
          }
            
          });
        }
        return filteredBundles;
      }

      const selectedRatePlan = vm.ratePlans.find(
        (x) => x.ratePlanID == service.ratePlanID
      );
      if (service.internetType === 'fibre' && selectedRatePlan && selectedRatePlan.fibre4GBackUp) {    
        var bundlesResult = vm.bundles.filter(
          (e) =>
            e.ratePlanId == selectedRatePlan.ratePlanID &&
            e.contractMonths == service.contractTerm &&
            e.usageType.toLowerCase() == 'mobile'
        );
        bundlesResult.push(vm.noneOption);
        return bundlesResult;
      }

      if (service.internetType === 'nbnEnterprise') {
        let hasRatePlanBundle = vm.bundles.filter(
          (e) =>
            e.contractMonths == service.contractTerm && e.usageType === 'mobile'
        );

        let hasMobile = hasRatePlanBundle.filter(
          (e) => e.ratePlanId === service.ratePlanID
        );
        hasMobile.push(vm.noneOption);

        let bundledService = vm.validBundleService(service);
        if (bundledService.length > 0) {
          vm.bundles.filter((x) => {
            if (
              x.bundleId == bundledService[0].bundleId &&
              x.usageType == 'mobile'
            )
              hasMobile.push(x);
          });
          bundledService;
        }
        if (hasMobile.length > 1) return hasMobile;
        if (hasMobile.length == 1) {
          let noRatePlanBundle = vm.bundles
            .filter(
              (e) =>
                e.contractMonths == service.contractTerm &&
                e.usageType === 'mobile'
            )
            .filter((x) => {
              switch (x.contractMonths) {
                case 0:
                  return x.ratePlanId == 1273;
                case 12:
                  return x.ratePlanId == 1243;
                case 36:
                  return x.ratePlanId == 1274;
              }
              return x;
            });
          noRatePlanBundle.push(vm.noneOption);
          return noRatePlanBundle;
        }
      }

      if (service.bundleId == 0) {
        let bundleList = vm.bundles
          .filter(
            (e) =>
              e.usageType === service.internetType &&
              e.contractMonths == service.contractTerm
          )
          .filter((x) => {
            if (x.usageType === 'nbn') {
              switch (x.contractMonths) {
                case 0:
                  return x.ratePlanId == 1273;
                case 12:
                  return x.ratePlanId == 1243;
                case 36:
                  return x.ratePlanId == 1274;
              }
            }
            return x;
          });
        bundleList.push(vm.noneOption);
        return bundleList;
      }
      if (usageType === 'nbn') {
        let newBundle = vm.bundles.filter(
          (e) =>
            e.contractMonths == service.contractTerm &&
            e.usageType.toLowerCase() == usageType.toLowerCase()
        );
        newBundle.push(vm.noneOption);
        return newBundle;
      } else {
        return vm.bundles.filter(
          (e) =>
            e.contractMonths == service.contractTerm &&
            e.usageType.toLowerCase() == usageType.toLowerCase()
        );
      }
    },
    validBundleService(service) {
      let vm = this;
      let bundlesSLA = vm.bundles.filter(
        (e) =>
          e.usageType == service.internetType &&
          e.contractMonths == service.contractTerm
      );

      let hasBundle = bundlesSLA.filter((e) => e.bundleId === service.bundleId);
      if (hasBundle.length > 0) return hasBundle;
      else {
        let filteredBundle = bundlesSLA.filter((e) => {
          if (e.serviceLevelID) {
            return (
              e.serviceLevelID.toLowerCase().includes('hr') &&
              e.ratePlanId == service.ratePlanID
            );
          }
        });

        if (filteredBundle.length > 0 && service.serviceLevelId == 0) {
          service.serviceLevelId = filteredBundle.filter((x) =>
            x.serviceLevelID.toLowerCase().includes('12hr')
          )[0].serviceLevelID;
        }

        return filteredBundle;
      }
    },
    hasIPServices: function () {
      let vm = this;
      let status;

      vm.getIPVoice().then(() => {
        if (this.order[0].ipOrderID > 0 || this.Sip.sip.sipId > 0)
          vm.hasIP = true;
        else if (this.order[0].customerDetails.ubAccountNo > 0) {
          this.getServices(this.order[0].customerDetails.ubAccountNo).then(
            (data) => {
              if (
                data &&
                data.length > 0 &&
                data.some((x) => x.type && x.type.toUpperCase() == 'VOIP')
              ) {
                status = true;
              } else {
                status = false;
              }

              vm.hasIP = status;
            }
          );
        } else vm.hasIP = false;
      });
    },
    changeRows: function () {
      let vm = this;
      var oldVal = vm.rows.length;
      var newVal = vm.NumberOfServiceInternet;

      if (parseInt(oldVal, 10) > parseInt(newVal, 10)) {
        this.$dialog
          .confirm('You are about to delete rows, are you sure?')
          .then(function () {
            vm.removeRows(newVal)
              .then(function () {
                vm.NumberOfServiceInternet = vm.rows.length;
                vm.checkDisabled4gBackup();
              })
              .catch(function () {
                vm.checkDisabled4gBackup();
                vm.NumberOfServiceInternet = vm.rows.length;
              });
          })
          .catch(function () {
            vm.NumberOfServiceInternet = oldVal;
            vm.checkDisabled4gBackup();
            return;
          });
      } else {
        if (newVal > this.rows.length)
          for (var i = oldVal; i < newVal; i++) {
            vm.addRow({
              addressID: vm.address.addresses[0].addressID,
              months: 24,
            });
          }
        vm.checkDisabled4gBackup();
      }
    },
    onAdd() {
      this.NumberOfServiceInternet++;
      this.$refs.txt.$emit('keyup');
    },
    onRemove() {
      this.NumberOfServiceInternet--;
      this.$refs.txt.$emit('keyup');
    },
    submit: function () {
      let vm = this;
      vm.isLoading = true;
      vm.$refs.observer.validate().then((result) => {
        if (result) {
          vm.addNewInternet(vm.rows)
            .then((data) => {
              vm.isSaved = true;
              vm.isLoading = false;
              vm.setMessage({
                message: 'Data saved successfully !',
                httpStatus: 200,
              });
              vm.checkDisabled4gBackup();
            })
            .catch((err) => {
              vm.isLoading = false;
              vm.isValid = false;
              if (err.response.data.message.includes('5G')) {
                vm.sqValidation = true;
                vm.hasUnsuccessfulSQ();
              }
              vm.setMessage({
                message: err.response.data.message,
                httpStatus: 500,
              });
              vm.checkDisabled4gBackup();
            });
        } else {
          vm.isValid = false;
          vm.setMessage({ message: 'unable to save', httpStatus: 500 });
        }
      });
    },
    saveNext: function () {
      this.$router.push('create-hardware/false');
    },
    async modalClosed() {
      this.showModal = false;
      await await this.getAllAddresses(this.customerID);
    },
    async contactClosed(payload) {
      let vm = this;
      this.showContact = false;
      if (typeof payload !== 'undefined') {
        vm.addContacts(payload);
      }
    },
    deleteFromOrder(internetID) {
      let vm = this;

      this.$dialog
        .confirm(
          'You are about to delete Internet from this order, this cannot be undone, are you sure?'
        )
        .then(function () {
          vm.removeRows(0).then(() => {
            vm.$router.push('order-summary');
            vm.checkDisabled4gBackup();
          });
        });
    },
    existingServicesLoaded(services) {
      let vm = this;
      Object.assign(vm.internetServices, services);
      vm.servicesLoaded = true;
    },
    showExistingServices() {
      let vm = this;
      vm.existingDialog = true;
    },
    addToTable(services) {
      let vm = this;
      let count = 0;
      let csnList = [];

      if (
        vm.rows[0].internetID === 0 &&
        vm.rows[0].internetType === null &&
        vm.rows[0].serviceNumber === null &&
        vm.rows[0].ratePlanID === 0 &&
        vm.rows[0].bundleId === 0 &&
        vm.rows[0].addressID
      ) {
        vm.delRow();
      }

      services.forEach((x) => {
        vm.addUpgradeRow({
          internetType: services[count].usageType.toLowerCase(),
          serviceNumber: services[count].csn,
          addressID: services[count].addressID,
          contractTerm: services[count].contractMonths,
          ratePlanID: services[count].ratePlanID,
          upgrade: true,
        });
        csnList.push(x.csn);
        count = count + 1;
      });

      this.NumberOfServiceInternet = vm.rows.length;
    },
    deleteRow(item, index) {
      let vm = this;

      let noteID = 0;
      if (vm.order[0].orderView && vm.order[0].orderView.internets) {
        vm.order[0].orderView.internets.forEach((x) => {
          if (x.serviceNumber === item.serviceNumber) {
            vm.notes.rows.forEach((y) => {
              if (y.noteText.includes(item.serviceNumber)) noteID = y.noteID;
            });
          }
        });
        vm.checkDisabled4gBackup();
      }

      if (item.internetID === 0) {
        vm.removeIndex(index);
        vm.checkDisabled4gBackup();
      } else {
        vm.removeRow(index);
        vm.checkDisabled4gBackup();
      }

      if (noteID > 0) {
        vm.delNote(noteID).then(() => {
          vm.getNotes('CreateInternet');
        });
      }
    },
    copyDown: function (column) {
      let vm = this;
      for (var i = 0; i < vm.rows.length; i++) {
        if (i > 0) vm.rows[i][column] = vm.rows[0][column];

        //Clear some fields if ordertype == port
      }
      return;
    },
    onServiceTypeChange(item) {
      item.contractTerm = -1;
      item.ratePlanID = null;
      item.modemRequired = null;
      item.dataBackup = ""
    },
    onSelect(value, index) {
      let vm = this;
      let selected = vm.bundles.filter((x) => x.ratePlanId === value);
      let selected_ratePlan = vm.ratePlans.find(x => x.ratePlanID == value);

      if (selected_ratePlan && selected_ratePlan.fibre4GBackUp) {
        vm.rows[index].bundleId = 0;
      } else if (selected.length == 0) {
        vm.rows[index].bundleId = 0;
        vm.rows[index].serviceLevelId = 0;
      }else{
        vm.rows[index].bundleId = selected[0].bundleId
      }

      if((selected_ratePlan && selected_ratePlan.ratePlanDescription.includes("Assure"))|| vm.rows[index].internetType != 'nbn'){
        vm.rows[index].modemRequired = false;
      }

      vm.checkDisabled4gBackup();
    },
    checkDisabled4gBackup() {
      let vm = this;
      vm.rows.forEach((row) => {
        let ratePlan = vm.ratePlans.filter(
          (x) => x.ratePlanID === row.ratePlanID
        )[0];
        if (ratePlan !== undefined)
          row.disable4GBackUp = ratePlan.disable4GBackUp;
        else row.disable4GBackUp = false;
      });
    },
    getInternetType(index) {
      let vm = this;
      let result = [...vm.internetType];
      if (vm.rows.length > 1 && index > 0) {
        if (vm.rows[0].internetType == 'nbnEnterprise') {
          result = vm.internetType.filter((e) => e.value == 'nbnEnterprise');
        }
        if (
          vm.rows[0].internetType !== null &&
          vm.rows[0].internetType !== 'nbnEnterprise'
        ) {
          result = vm.internetType.filter((e) => e.value != 'nbnEnterprise');
        }
      }
      return result;
    },
    removeDataBackupFromInternet(item) {
      const vm = this;
      const rowToUpdate = vm.rows.find(e => e.internetID === item.internetID);
      if (rowToUpdate) {
        rowToUpdate.dataBackup = null;
      }
    },
    editBackup(item, index) {
      this.itemToBackup = item;
      this.backupData = item;
      this.currentIndex = index;
      this.selectedInternet = item;

      this.dialog = {
        title: 'Edit 4G Backup',
        target: 'edit',
        active: true,
      };
    },
    updateInternet(data){
      if (data.item) {
        this.rows[data.index].modemRequired = false;
      }
    },
    updateBackup (item){
      if (this.allFlags.SOG4015) {
        if (item.dataBackup) {
         item.modemRequired =false
          
        }
      }else{
        if (item.bundleId) {
          item.modemRequired =false
        }
      }
    }
  },
  watch: {
    rows: function () {
      let vm = this;
      vm.NumberOfServiceInternet = vm.rows.length;
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/custom-styles.scss';

.iconBtn {
  width: 56px;
  height: 24px;
  min-width: 56px;
  margin: 0;
}

.sqResult {
  ::v-deep
    .theme--light.v-text-field
    > .v-input__control
    > .v-input__slot:before {
    color: #f44336 !important;
  }

  ::v-deep .theme--light.v-select .v-select__selections {
    color: #f44336 !important;
  }

  ::v-deep input {
    color: #f44336 !important;
  }

  ::v-deep .v-input__slot::before {
    border-color: #f44336 !important;
  }
}
</style>
